import { SupportAgentTicket } from "@src/types/support";

export const returnMachineName = (ticket: SupportAgentTicket): string | null =>
  ticket.machine?.machine_name || ticket.machine?.machine_id || null;
